import { render } from "./ButtonWithIconContacts.vue?vue&type=template&id=2963f71e&scoped=true"
import script from "./ButtonWithIconContacts.vue?vue&type=script&lang=js"
export * from "./ButtonWithIconContacts.vue?vue&type=script&lang=js"

import "./ButtonWithIconContacts.vue?vue&type=style&index=0&id=2963f71e&lang=scss&scoped=true"

import exportComponent from "/home/esesja/domains/app.esesja.mda.pl/public_html/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2963f71e"]])

export default __exports__